import React from 'react';

const LoaderSVG = () => (
  <svg
    className="loader-svg"
    width="22px"
    height="22px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <rect x="0" y="0" width="100" height="100" fill="none" />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(0 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(30 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(60 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(90 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(120 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(150 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(180 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(210 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(240 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(270 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(300 50 50) translate(0 -30)"
    />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#000000"
      transform="rotate(330 50 50) translate(0 -30)"
    />
  </svg>
);

export default LoaderSVG;
